/**
 * data-test-id values for Borg company onboarding (shareable link flow).
 * Used by Weyoun e2e via getByTestId.
 */
export const CompanyOnboardingTestId = {
  ROOT: "co-onboard-root",
  HEADER_SUBTITLE: "co-onboard-header-subtitle",

  FOOTER_NEXT: "co-onboard-footer-next",
  FOOTER_FINISH: "co-onboard-footer-finish",
  FOOTER_BACK: "co-onboard-footer-back",

  UBO_ENTRY_TRIGGER: "co-onboard-ubo-entry-trigger",
  UBO_MODAL_FORM: "co-onboard-ubo-modal-form",
  UBO_UPLOAD_GOVERNMENT_ID: "co-onboard-ubo-upload-government-id",
  UBO_GOVERNMENT_ID_VERIFIED: "co-onboard-ubo-government-id-verified",
  /** UBO modal ControlledInput: `${UBO_FIELD_PREFIX}${field.name}` */
  UBO_FIELD_PREFIX: "co-onboard-ubo-field-",

  /** Prefix for business-details ControlledInput fields: `${FIELD_PREFIX}${propertyId}` */
  FIELD_PREFIX: "co-onboard-field-",

  AGREEMENTS_REVIEW_ESIGN: "co-onboard-agreements-review-esign",
  AGREEMENTS_FORM: "co-onboard-agreements-form",
  /** Row wrapper: `${AGREEMENT_ROW_PREFIX}${propertyId}` */
  AGREEMENT_ROW_PREFIX: "co-onboard-agreement-",

  ESIGN_MODAL: "co-onboard-esign-modal",
  ESIGN_STEP_INDICATOR: "co-onboard-esign-step-indicator",
  ESIGN_PDF_SCROLL: "co-onboard-esign-pdf-scroll",
  ESIGN_ELECTRONIC_COMM_ROW: "co-onboard-esign-electronic-comm",
  ESIGN_AGREE_AND_SIGN: "co-onboard-esign-agree-and-sign",
  ESIGN_DONE: "co-onboard-esign-done",
  /** Matches SignatureBox canvas (shared with I-9 flow). */
  ESIGN_SIGNATURE_CANVAS: "onboard-i9-signature-canvas",

  BANKING_PREFIX: "co-onboard-banking-",

  EIN_FILE_INPUT: "co-onboard-ein-file-input",

  FINISH_HEADING: "co-onboard-finish-heading",
  FINISH_MESSAGE: "co-onboard-finish-message",
} as const;
